import {mediaBreakpointDown, mediaBreakpointUp} from './styleVariables';

export const hiddenMobileDownStyle = `
  ${mediaBreakpointDown('mobile')} {
    display: none !important;
  }
`;

export const hiddenTabletDownStyle = `
  ${mediaBreakpointDown('tablet')} {
    display: none !important;
  }
`;

export const hiddenDesktopDownStyle = `
  ${mediaBreakpointDown('desktop')} {
    display: none !important;
  }
`;

export const hiddenTabletUpStyle = `
  ${mediaBreakpointUp('tablet')} {
    display: none !important;
  }
`;

export const hiddenDesktopUpStyle = `
  ${mediaBreakpointUp('desktop')} {
    display: none !important;
  }
`;

export const hiddenDesktopWideUpStyle = `
  ${mediaBreakpointUp('desktop-wide')} {
    display: none !important;
  }
`;

export const hiddenStyle = `
  display: none !important;
`;
